var map = {
	"./equipments-page/equipment-Cap-02.png": "05a7",
	"./equipments-page/equipment-Cap-03.png": "6f98",
	"./equipments-page/equipment-badge.jpg": "0c5b",
	"./equipments-page/equipment-cap-01.png": "4e43",
	"./equipments-page/equipment-cap-02.png": "65d1",
	"./equipments-page/equipment-cap-03.png": "de28",
	"./equipments-page/equipment-coat-01.png": "457e",
	"./equipments-page/equipment-coat-02.png": "3556",
	"./equipments-page/equipment-sticker-01.png": "9477",
	"./equipments-page/equipment-sticker-02.png": "3531",
	"./event-decoration-page/events-01.png": "642e",
	"./icons/download-icons/ai.svg": "3db8",
	"./icons/download-icons/figma.svg": "6299",
	"./icons/download-icons/otf.svg": "047a",
	"./icons/download-icons/pdf.svg": "c098",
	"./icons/download-icons/png.svg": "5aa8",
	"./icons/download-icons/ttf.svg": "0c04",
	"./icons/download-icons/woff.svg": "4af5",
	"./icons/icon-aep.svg": "2a4c",
	"./icons/icon-ai.svg": "f4f1",
	"./icons/icon-doc.svg": "d869",
	"./icons/icon-error.svg": "b266",
	"./icons/icon-figma.svg": "68fa",
	"./icons/icon-mp4.svg": "2aa2",
	"./icons/icon-otf.svg": "76e4",
	"./icons/icon-png.svg": "1757",
	"./icons/icon-row.svg": "b27d",
	"./icons/icon-success.svg": "9bad",
	"./icons/icon-woff.svg": "cd0c",
	"./icons/icon-zip.svg": "e428",
	"./icons/quotes-error.svg": "01c2",
	"./icons/quotes-success.svg": "90d9",
	"./icons/row-grey-small.svg": "1cad",
	"./interior-page/interior-01.png": "07a0",
	"./logo-main.svg": "4f57",
	"./logo-page/icon-h.svg": "a984",
	"./logo-page/icon-v.svg": "2594",
	"./logo-page/logo-01.png": "2981",
	"./logo-page/logo-02.png": "738d",
	"./logo-page/logo-h.png": "2b63",
	"./logo-page/logo-safezone.png": "d973",
	"./logo-page/logo-v.png": "ccdd",
	"./logo-page/slides-second/logo-01.png": "320d",
	"./logo-page/slides-second/logo-02.png": "9b34",
	"./logo-page/slides-second/logo-03.png": "6c3d",
	"./logo-page/slides-three/logo-b.png": "4cca",
	"./logo-page/slides-three/logo-w.png": "2219",
	"./logo-page/slides/logo-01.png": "7e3a",
	"./logo-page/slides/logo-02.png": "033f",
	"./logo-page/slides/logo-03.png": "2087",
	"./logo-page/slides/logo-04.png": "8917",
	"./logo.svg": "1ae4",
	"./office-identity-page/office-badge.jpg": "8afb",
	"./office-identity-page/office-blank.jpg": "316b",
	"./office-identity-page/office-cards-en.jpg": "dea3",
	"./office-identity-page/office-cards-ru.jpg": "c6b9",
	"./office-identity-page/slides/office-layout.png": "76cb",
	"./office-identity-page/slides/office-screen-01.jpg": "b04a",
	"./office-identity-page/slides/office-screen-02.jpg": "54a9",
	"./office-identity-page/slides/office-screen-03.jpg": "38a0",
	"./office-identity-page/slides/office-screen-04.jpg": "86a7",
	"./page-top-img.jpg": "7ac5",
	"./page-top-img.svg": "5cf1",
	"./patterns-page/Identity-Pattern1.jpg": "1359",
	"./patterns-page/Identity-Pattern1.svg": "9cef",
	"./patterns-page/Identity-Pattern2.jpg": "3fda",
	"./patterns-page/Identity-Pattern2.svg": "ea4d",
	"./patterns-page/Identity-Pattern3.jpg": "2e4a",
	"./patterns-page/Identity-Pattern3.svg": "53df",
	"./patterns-page/Identity-Pattern4.jpg": "95d9",
	"./patterns-page/Identity-Pattern4.svg": "9561",
	"./patterns-page/Identity-Pattern5.jpg": "acd3",
	"./patterns-page/Identity-Pattern5.svg": "3df4",
	"./pc-bg.png": "1be6",
	"./photo-page/photo-1.jpg": "9953",
	"./photo-page/photo-2.jpg": "3bd7",
	"./photo-page/photo-3.jpg": "50fd",
	"./photo-page/photo-4.jpg": "a763",
	"./photo-page/photo-5.jpg": "8649",
	"./photo-page/photo-6.jpg": "3941",
	"./picto-page/1.svg": "3296",
	"./picto-page/Steor-Icon-01.svg": "2134",
	"./picto-page/Steor-Icon-02.svg": "7703",
	"./picto-page/Steor-Icon-03.svg": "35a9",
	"./picto-page/Steor-Icon-04.svg": "79e1",
	"./picto-page/Steor-Icon-05.svg": "f676",
	"./picto-page/Steor-Icon-06.svg": "5cc3",
	"./picto-page/Steor-Icon-07.svg": "498d",
	"./picto-page/Steor-Icon-08.svg": "db91",
	"./picto-page/Steor-Icon-09.svg": "864e",
	"./picto-page/Steor-Icon-10.svg": "62c4",
	"./picto-page/Steor-Icon-11.svg": "92e8",
	"./presentations-page/pres-01.png": "578c",
	"./presentations-page/pres-02.png": "6e83",
	"./presentations-page/pres-03.png": "eba9",
	"./presentations-page/pres-04.png": "3dc1",
	"./presentations-page/pres-05.png": "4ff7",
	"./presentations-page/pres-06.png": "70ab",
	"./presentations-page/pres-07.png": "b310",
	"./presentations-page/pres-08.png": "0797",
	"./presentations-page/pres-09.png": "7b7c",
	"./presentations-page/pres-10.png": "fa96",
	"./slides/logo-black.svg": "d943",
	"./slides/logo-blue.svg": "5e3d",
	"./slides/logo-grey.svg": "0afb",
	"./slides/logo-white.svg": "3e35",
	"./souvenir-page/slider/notepad-01.png": "aaaa",
	"./souvenir-page/slider/notepad-02.png": "1153",
	"./souvenir-page/slider/notepad-03.png": "ccc9",
	"./souvenir-page/souvenirs-01.png": "e06d",
	"./souvenir-page/souvenirs-02.png": "32b3",
	"./souvenir-page/souvenirs-thermos-01.png": "5277",
	"./souvenir-page/souvenirs-thermos-02.png": "ea7d",
	"./style-page/font.svg": "44cd",
	"./style-page/hud-01.png": "3d8d",
	"./style-page/hud-02.png": "5070",
	"./style-page/hud-03.png": "9023",
	"./style-page/hud-04.png": "40e5",
	"./style-page/hud-05.png": "e121",
	"./style-page/hud-06.png": "d033",
	"./style-page/photo-01.png": "f8bc",
	"./style-page/photo-02.png": "fa6e",
	"./style-page/photo-03.png": "4ff8",
	"./style-page/photo-04.png": "098f",
	"./style-page/style-01.png": "4d90",
	"./style-page/typo-01.png": "aa2f",
	"./style-page/typo-02.png": "67c5",
	"./typography-page/pt-root/pt-root-01.svg": "5a26",
	"./typography-page/pt-root/pt-root-02.svg": "7bb1",
	"./typography-page/pt-root/pt-root-03.svg": "7296",
	"./typography-page/pt-root/pt-root-04.svg": "7a59",
	"./typography-page/stapel-text/stapel-text-01.svg": "25de",
	"./typography-page/stapel-text/stapel-text-02.svg": "af8e",
	"./typography-page/stapel-text/stapel-text-03.svg": "efcf",
	"./typography-page/stapel/stapel-01.svg": "59fc",
	"./typography-page/stapel/stapel-02.svg": "c1b4",
	"./typography-page/stapel/stapel-03.svg": "2d8d",
	"./typography-page/stapel/stapel-04.svg": "d1c8",
	"./typography-page/typography-01.png": "4be3",
	"./video-and-animation-page/brand-video.gif": "cee1",
	"./video-and-animation-page/brand-video.mp4": "a614",
	"./video-and-animation-page/video.png": "b2bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";